/**
 * Stage ordering, labels, and colors for gov solicitation pipelines.
 * Shared between GovSolicitationDetailPage and other views.
 */

export const SS_STAGES = [
  'identified', 'go_no_go', 'engage_poc', 'teaming_assessment',
  'write_response', 'submit_response', 'confirm_receipt', 'request_follow_up',
  'demo_capability_brief', 'confirm_solicitation_date', 'solicitation_released',
  'no_response_needed', 'not_converted', 'converted',
];

export const ACTIVE_STAGES = [
  'identified', 'analyzing', 'go_no_go', 'bid_prep', 'proposal_writing',
  'bonding', 'submitted', 'proposal_verification', 'monitoring_for_award',
  'won', 'lost', 'no_bid', 'cancelled',
];

export const STAGE_LABELS: Record<string, string> = {
  identified: 'Identified',
  go_no_go: 'Go / No-Go',
  engage_poc: 'Engage POC',
  teaming_assessment: 'Teaming Assessment',
  write_response: 'Write Response',
  submit_response: 'Submit Response',
  confirm_receipt: 'Confirm Receipt',
  request_follow_up: 'Request Follow-Up',
  demo_capability_brief: 'Demo / Capability Brief',
  confirm_solicitation_date: 'Confirm Sol Date',
  solicitation_released: 'Solicitation Released',
  no_response_needed: 'No Response Needed',
  not_converted: 'Not Converted',
  converted: 'Converted',
  analyzing: 'Analyzing',
  bid_prep: 'Bid Prep',
  proposal_writing: 'Proposal Writing',
  bonding: 'Bonding',
  submitted: 'Submitted',
  proposal_verification: 'Proposal Verification',
  monitoring_for_award: 'Monitoring for Award',
  won: 'Won 🏆',
  lost: 'Lost',
  no_bid: 'No Bid',
  cancelled: 'Cancelled',
};

export const STAGE_COLORS: Record<string, string> = {
  identified: '#4a7eb5', go_no_go: '#8b5cf6', engage_poc: '#6366f1',
  teaming_assessment: '#7c3aed', write_response: '#ec4899', submit_response: '#f97316',
  confirm_receipt: '#84cc16', request_follow_up: '#eab308', demo_capability_brief: '#22c55e',
  confirm_solicitation_date: '#10b981', solicitation_released: '#10b981',
  analyzing: '#4a7eb5', bid_prep: '#6366f1', proposal_writing: '#ec4899', bonding: '#f59e0b',
  submitted: '#84cc16', proposal_verification: '#eab308', monitoring_for_award: '#22c55e',
  won: '#10b981', lost: '#ef4444', no_bid: '#64748b', cancelled: '#4a6580',
  no_response_needed: '#64748b', not_converted: '#4a6580', converted: '#10b981',
};

export function stageOrderFor(pipeline: string): string[] {
  if (pipeline === 'sources_sought') return SS_STAGES;
  if (pipeline === 'active') return ACTIVE_STAGES;
  return [];
}
